var exports = {
  "container": "x43cbe9c2--d7056b--container",
  "wrapper": "x43cbe9c2--d7056b--wrapper",
  "textblock": "x43cbe9c2--d7056b--textblock",
  "title": "x43cbe9c2--d7056b--title",
  "description": "x43cbe9c2--d7056b--description",
  "image": "x43cbe9c2--d7056b--image",
  "tablet": "x43cbe9c2--d7056b--tablet",
  "phone": "x43cbe9c2--d7056b--phone",
};

module.exports = exports;
